module.exports = __webpack_public_path__ + "img/3.f8290d35.jpg";